import { render } from "./OcrConfigurationInterfaceView.vue?vue&type=template&id=1bbcced0&scoped=true&ts=true"
import script from "./OcrConfigurationInterfaceView.vue?vue&type=script&lang=ts"
export * from "./OcrConfigurationInterfaceView.vue?vue&type=script&lang=ts"

import "./OcrConfigurationInterfaceView.vue?vue&type=style&index=0&id=1bbcced0&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbcced0"]])

export default __exports__